import { FC, Fragment } from 'react';
import { Column } from 'ts/shared/interfaces/Generic';
import withErrorBoundary from '../withErrorBoundary';

interface MoGroupDataProps {
  columns: Column[];
  data: any;
  columnsCount?: number;
  columnWidth?: number;
  mainClassName?: string;
}

const MoGroupData: FC<MoGroupDataProps> = (props) => {
  if (!props.data || !props.columns) return null;
  const titleWidth = props.columnWidth ?? 110;
  return (
    <div className={'mo-group-wr' + (props.mainClassName ? ' ' + props.mainClassName : '')}>
      {props.columns.map((column, index) => (
        <div
          key={index}
          className={'mo-group' + (column.className ? ' ' + column.className : '')}
          style={{ width: props.columnsCount ? 100 / props.columnsCount - 1 + '%' : '' }}
        >
          <div className="mo-group-title" style={{ width: titleWidth + 'px' }}>
            {!!column.labelJsx && column.helpLabel ? (
              <column.labelJsx stringParam1={props.data[column.helpLabel]} />
            ) : (
              column.label
            )}
          </div>

          <div className="mo-group-data position-relative">
            {column.format === 'html' &&
              !!column.helpField &&
              typeof props.data[column.helpField] === 'string' && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: props.data[column.helpField] || '',
                  }}
                />
              )}
            {column.format === 'jsx' &&
              !!column.helpField &&
              typeof props.data[column.helpField] !== 'string' && (
                <Fragment>{props.data[column.helpField]}</Fragment>
              )}
            {!column.format && props.data[column.field]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default withErrorBoundary(MoGroupData, 'MoGroupData');
